<template>
	<div class="block-editor-widget-layout-row-edit" :class="{ current: editField == field }" ref="container">
		<WidgetFieldWrapper
			:field="field"
			v-if="field.id"
			v-on="$listeners"
			:editMode="editMode"
			:testResponse="testResponse"
			:previousSteps="previousSteps"
			:replaceInsertDataStringDict="replaceInsertDataStringDict"
			:configurationsMappingBlocksUUIDs="configurationsMappingBlocksUUIDs"
			:key="JSON.stringify(field.metadata)"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import WidgetFieldWrapper from '@/components/WidgetForm/WidgetFieldWrapper';

export default {
	name: 'BlockEditorWidgetLayoutRowEdit',
	components: {
		WidgetFieldWrapper,
	},
	props: {
		field: { type: Object },
		editMode: { type: Boolean },
		testResponse: { type: Object },
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},

	methods: {
		getBoundingClientRect() {
			// DO NOT delete! (used from parent)
			return this.$refs.container.getBoundingClientRect();
		},
	},
	computed: {
		...mapGetters('widgetEditor', ['editField']),
	},
};
</script>

<style>
.block-editor-widget-layout-row-edit {
	padding: 10px 15px 0 15px;
	transition: all 0.35s;
	cursor: pointer;
	min-height: 44px;
}
</style>
